const getLocale = () => document.documentElement.lang

// eslint-disable-next-line import/prefer-default-export
export { getLocale }
